import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import usersEsCL from './locales/es-CL.json';
import usersEnUS from './locales/en-US.json';
import usersPtBR from './locales/pt-BR.json';

export const usersI18n = buildScopedI18n({
  esCL: usersEsCL,
  enUS: usersEnUS,
  ptBR: usersPtBR,
});
